import EscalationFollowUp from "./EscalationFollowUp";

export default EscalationFollowUp;
